<template>
	<div class="order">
		<div class="tabs">
			<div class="tabs_box d-flex j-sb a-center position-relative">
				<div class="button" :ref="`tabs`" :style="cur_index==index?'color:#1E69FF;':''"
					v-for="(item,index) in tabs_list" @click="change($event,index)">{{item.name}}</div>
				<div class="underline" :style="underline_style"></div>
			</div>
			<component :is="cur_component"></component>
		</div>
	</div>
</template>

<script>
	const all = () => import('./list/all.vue')
	const unpaid = () => import('./list/unpaid.vue')
	const unpicked = () => import('./list/unpicked.vue')
	const undelivered = () => import('./list/undelivered.vue')
	const canceled = () => import('./list/canceled.vue')
	const done = () => import('./list/done.vue')
	const unjudged = () => import('./list/unjudged.vue')
	const aftersale = () => import('./list/aftersale.vue')
	const unpay = () => import('./list/unpay.vue')
	const unreceiving = () => import('./list/unreceiving.vue')
	export default {
		components: {
			all,
			unpaid,
			unpicked,
			undelivered,
			canceled,
			done,
			unjudged,
			aftersale,
			unpay,
			unreceiving
		},
		data() {
			return {
				cur_component: '',
				tabs_list: [{
					name: '全部(0)',
					component: 'all'
				}, {
					name: '待付款(2365)',
					component: 'unpay'
				}, {
					name: '待发货(2365)',
					component: 'undelivered'
				}, {
					name: '待收货(2365)',
					component: 'unreceiving'
				},{
					name: '待取货(2365)',
					component: 'unpicked'
				}, {
					name: '已取消(2365)',
					component: 'canceled'
				}, {
					name: '已完成(2365)',
					component: 'done'
				}, {
					name: '待评价(2365)',
					component: 'unjudged'
				}, {
					name: '退/换售后(2365)',
					component: 'aftersale'
				}],
				cur_index: 0,
				underline_style: '',
				activeName: 'second',
			};
		},
		mounted() {
			this.getHomeData()
			this.change()
			window.onresize = () => {
				this.change()
			}
		},
		methods: {
			change(e, index) {
				console.log(index)
				if (index !== undefined) {
					this.cur_index = index
				}
				this.cur_component = this.tabs_list[this.cur_index].component
				this.underline_style =
					`left:calc(${this.$refs.tabs[this.cur_index].offsetLeft}px + 1rem);width:calc(${this.$refs.tabs[this.cur_index].offsetWidth}px - 2rem)`
			},
			getHomeData() {
				let param = {
					act: 'order_data',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.homeData(param).then((res) => {
					let str1 = parseInt(res.data.await_pay) + parseInt(res.data.await_ship) + parseInt(res.data.await_pickup) + parseInt(res.data.order_cancelled) + parseInt(res.data.finished) + parseInt(res.data.await_comment) + parseInt(res.data.return_number)
					this.tabs_list[0].name = '全部('+str1+')'
					let str2 = parseInt(res.data.await_pay)
					this.tabs_list[1].name = '待付款('+str2+')'
					let str3 = parseInt(res.data.await_ship)
					this.tabs_list[2].name = '待发货('+str3+')' 
					let str4 = parseInt(res.data.await_pickup)
					this.tabs_list[4].name = '待取货('+str4+')'
					let str5 = parseInt(res.data.order_cancelled)
					this.tabs_list[5].name = '已取消('+str5+')'
					let str6 = parseInt(res.data.finished)
					this.tabs_list[6].name = '已完成('+str6+')'
					let str7 = parseInt(res.data.await_comment)
					this.tabs_list[7].name = '待评价('+str7+')'
					let str8 = parseInt(res.data.return_number)
					this.tabs_list[8].name = '退/换售后('+str8+')'
					let str9 = parseInt(res.data.await_receiving)
					this.tabs_list[3].name = '待收货('+str9+')'
					
				})
			}
			
		}
	};
</script>
<style lang="scss">
	.el-table thead {
		color: #000000 !important;
		font-size: 0.88rem;
		th{
			background: linear-gradient(0deg, #F8F8F8 0%, #F4F4F4 100%)!important;
		}
	}
</style>
<style lang="scss" scoped>
	.order {
		height: 100%;
		max-width: 73.24rem;
		margin: 0 auto;

		.tabs {
			width: 100%;

			.tabs_box {
				width: 100%;
				background: linear-gradient(0deg, #F4F4F4 0%, #FFFFFF 100%);
				border-radius: 6px 6px 0 0;

				.button {
					height: 3.5rem;
					line-height: 3.5rem;
					padding: 0 1rem;
					text-align: center;
					font-size: 0.88rem;
					font-weight: bold;
					cursor: pointer;
					box-sizing: border-box;
					color: #666666;
					user-select: none;
					&:hover {
						color: #1E69FF;
					}
				}

				.underline {
					height: 0.19rem;
					background: #1E69FF;
					position: absolute;
					bottom: .5rem;
					transition: all .2s ease;
				}
			}
		}
	}
</style>
